import axiosInstance from '../utils/AxiosConfig';

export const getStockCountConfig = async (locationId) => {
  const response = await axiosInstance.get('/stock-count/config', {
    params: { locationId: locationId || undefined },
  });
  return response.data.data;
};

export const saveStockCountConfig = async (payload) => {
  const response = await axiosInstance.put('/stock-count/config', payload);
  return response.data.data;
};

export const getStockCountConfigPreview = async ({ referenceTypes, recurrenceType, weeklyDays, fullCycleDays, locationId }) => {
  const response = await axiosInstance.get('/stock-count/config/preview', {
    params: {
      referenceTypes: referenceTypes && referenceTypes.length ? referenceTypes.join(',') : undefined,
      recurrenceType,
      weeklyDays: weeklyDays && weeklyDays.length ? weeklyDays.join(',') : undefined,
      fullCycleDays,
      locationId: locationId || undefined,
    },
  });
  return response.data.data;
};

export const listStockCountConfigs = async () => {
  const response = await axiosInstance.get('/stock-count/configs');
  return response.data.data;
};

export const deleteStockCountConfig = async (locationId) => {
  const response = await axiosInstance.delete('/stock-count/config', {
    params: { locationId: locationId || undefined },
  });
  return response.data.data;
};

export const getTodaysStockCountSession = async (locationId) => {
  const response = await axiosInstance.get(`/stock-count/session/${locationId}`);
  return response.data.data;
};

export const registerStockCountAttempt = async (itemId, countedStock) => {
  const response = await axiosInstance.post(`/stock-count/session/items/${itemId}/attempts`, {
    counted_stock: countedStock,
  });
  return response.data.data;
};

export const getPendingStockCountAdjustments = async () => {
  const response = await axiosInstance.get('/stock-count/adjustments');
  return response.data.data;
};

export const reviewStockCountAdjustment = async (adjustmentId, approve, notes) => {
  const response = await axiosInstance.post(`/stock-count/adjustments/${adjustmentId}/review`, {
    approve,
    notes: notes || undefined,
  });
  return response.data.data;
};

export const getStockCountCoverageReport = async () => {
  // Reporte opcional (plugin apagado o sin permiso pueden dar 403) -- no debe
  // disparar el redirect global a /permission-denied, InventoryReports.jsx ya
  // maneja el error ocultando la sección.
  const response = await axiosInstance.get('/stock-count/reports/coverage', {
    skipGlobalErrorRedirect: true,
  });
  return response.data.data;
};

export const getTodayStockCountControl = async () => {
  const response = await axiosInstance.get('/stock-count/control');
  return response.data.data;
};

export const getCurrentCycleStockCountControl = async () => {
  const response = await axiosInstance.get('/stock-count/control/cycle');
  return response.data.data;
};
